import { ChangeEventHandler, FC, ReactNode } from 'react';
import { useIntl, defineMessages } from 'dibs-react-intl';
import { useGetYesNoOptions } from '../../helpers/sellerApplicationOptions';

import { BasicSelect } from 'dibs-elements/exports/BasicSelect';

const messages = defineMessages({
    experienceSellingOnlinePlaceholder: {
        id: 'SellerApplicationForm.ExperienceSellingOnline.experienceSellingOnlinePlaceholder',
        defaultMessage: 'Do you have experience selling online?',
    },
});

type Props = {
    onChange: ChangeEventHandler<HTMLSelectElement>;
    errorMessage: ReactNode;
    disabled?: boolean;
};

const ExperienceSellingOnline: FC<Props> = ({ onChange, errorMessage, disabled }) => {
    const intl = useIntl();

    return (
        <BasicSelect
            dataTn="experience-selling-online"
            placeholder={intl.formatMessage(messages.experienceSellingOnlinePlaceholder)}
            hasAnimatedPlaceholder
            options={useGetYesNoOptions()}
            onChange={onChange}
            errorMessage={errorMessage}
            hasError={!!errorMessage}
            disabled={disabled}
        />
    );
};

export default ExperienceSellingOnline;
